const STORAGE_KEY = 'account-switch-notice'

// リロードをまたいでメッセージを渡すため localStorage に保存する
export function setAccountSwitchNotice(message: string) {
  try {
    localStorage.setItem(STORAGE_KEY, message)
  } catch {
    // プライベートモード等で localStorage が使えない場合は通知を諦める
  }
}

// 保存済みのメッセージを読み出して削除する
export function consumeAccountSwitchNotice(): string | null {
  try {
    const message = localStorage.getItem(STORAGE_KEY)
    localStorage.removeItem(STORAGE_KEY)
    return message
  } catch {
    // プライベートモード等で localStorage が使えない場合は通知を諦める
    return null
  }
}
